export const dbPanels = {
  images: {
    subtitle: `Envie, reordene e defina a foto principal de cada unidade exibida no seu motor de reservas.`,
  },

  amenities: {
    searchPlaceholder: `Buscar comodidade…`,
    selectedCount: `{count} comodidade selecionada | {count} comodidades selecionadas`,
    noResults: `Nenhum resultado para "{query}".`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `O agente vai mostrá-las ao hóspede que perguntar por esta comodidade.`,
      dropTitle: `Arraste as fotos para aqui`,
      addPhotos: `Adicionar fotos`,
      dropHint: `JPG, PNG, WebP ou HEIC · até {mb} MB cada`,
      dropActive: `Solte para enviar`,
      uploading: `Enviando… {progress}%`,
      uploaded: `{count} foto adicionada | {count} fotos adicionadas`,
      counter: `{count} foto | {count} fotos`,
      remaining: `Pode adicionar mais {count} foto | Pode adicionar mais {count} fotos`,
      full: `Já tem o máximo de {max} fotos`,
      tooMany: `Só cabem {max} fotos por comodidade.`,
      tooHeavy: `«{name}» tem mais de {mb} MB. Reduza antes de enviar.`,
      notImage: `«{name}» não é uma imagem.`,
      uploadError: `Não foi possível enviar as fotos.`,
      removeAria: `Remover esta foto`,
      deleteTitle: `Remover esta foto?`,
      deleteBody: `O agente deixará de mostrá-la quando perguntarem por «{amenity}». Não é possível desfazer.`,
      deleteCancel: `Cancelar`,
      deleteConfirm: `Remover foto`,
      deleted: `Foto removida`,
      deleteError: `Não foi possível remover a foto.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `O agente mostra as {count} primeiras. Arraste pela alça para mudar a ordem.`,
      dragTitle: `Arraste para ordenar`,
      reordering: `Salvando a ordem…`,
      orderSaved: `Ordem salva`,
      orderError: `Não foi possível salvar a ordem.`,
      willSend: `O agente vai enviar esta foto`,
      wontSend: `O agente não chega a enviar esta foto`,
      someFailed: `Não foi possível processar: {names}`,
    },
  },

  occupancy: {
    question: `Qual ajuste você gostaria de aplicar?`,
    questionRoom: `Qual ajuste você gostaria de aplicar a este quarto?`,
    modeNone: `Nenhum`,
    modeReduction: `Redução`,
    modeSurcharge: `Acréscimo`,
    baseOccupancy: `Ocupação base`,
    baseHint: `hóspedes (o preço padrão)`,
    thOccupancy: `Ocupação`,
    thRule: `Regra`,
    thValue: `Valor`,
    thActive: `Ativo`,
    guestsCount: `{count} hóspede | {count} hóspedes`,
    ruleReductionPct: `Redução %`,
    ruleReductionFixed: `Redução {currency}`,
    reductionInfo: `Para menos hóspedes que a ocupação base, esta redução se aplica ao preço da acomodação.`,
    priceIncludes: `O preço inclui`,
    guestsCapacity: `hóspede (capacidade do quarto) | hóspedes (capacidade do quarto)`,
    maxExtraGuests: `Máx. de hóspedes extras`,
    chargePerExtraGuest: `Cobrança por hóspede extra`,
    chargeFixed: `{currency} fixo`,
    perNight: `por noite`,
    surchargeInfo: `Cada hóspede acima da capacidade incluída paga esta cobrança por noite.`,
    noneRoom: `Este quarto não tem ajuste de ocupação: o mesmo preço para qualquer número de hóspedes (dentro da capacidade).`,
    noneBooking: `Esta reserva não tem ajuste de ocupação: o mesmo preço para qualquer número de hóspedes (dentro da capacidade).`,
  },

  share: {
    title: `Compartilhar (Hotel)`,
    desc: `Este link é específico deste hotel. Compartilhe-o pelo WhatsApp ou abra-o como visitante.`,
    linkLabel: `Link de reservas do hotel`,
    linkHint: `Use-o na sua bio, campanhas ou mensagens automáticas.`,
    viewAsVisitor: `Ver como visitante`,
    tip: `Dica: você pode enviar este link com a mensagem de confirmação da reserva.`,
    noLinkCopy: `Nenhum link para copiar.`,
    copied: `Link copiado.`,
    copyError: `Não foi possível copiar o link.`,
    noLinkShare: `Nenhum link para compartilhar.`,
    whatsappMsg: `Olá 👋 Aqui está o link para reservar neste hotel: {link}`,
    noLinkOpen: `Nenhum link para abrir.`,
  },

  unitServices: {
    title: `Equipamentos e comodidades`,
    subPrefix: `Comodidades de`,
    thisRoom: `este quarto`,
    subInfo: `Cada tipo de quarto tem as suas; a reserva direta e o Agente IA usam as do quarto atribuído ao hóspede.`,
    loading: `Carregando comodidades…`,
    loadError: `Não foi possível carregar as comodidades deste quarto.`,
    retry: `Tentar novamente`,
    saving: `Salvando…`,
    saved: `Salvo`,
    autosaveHint: `As alterações são salvas automaticamente conforme você marca ou desmarca.`,
  },

  welcome: {
    tag: `Motor de reservas diretas`,
    titleA: `Receba reservas`,
    titleHighlight: `sem comissões`,
    sub: `Seu próprio motor de reservas por propriedade: compartilhe um link, o hóspede reserva e paga diretamente. Sem intermediários, sem comissões de OTA.`,
    howItWorks: `Como funciona`,
    benefits: `Benefícios`,
    step1Title: `Compartilhe seu link`,
    step1Text: `Cada propriedade tem seu próprio link. Publique-o no seu site, redes sociais ou WhatsApp; o agente IA também o envia aos leads.`,
    step2Title: `O hóspede reserva`,
    step2Text: `Ele escolhe as datas e paga no seu motor. A reserva cai direto no seu calendário, sem comissões de OTA.`,
    step3Title: `Você recebe diretamente`,
    step3Text: `Receba o pagamento sem intermediários e adicione promoções, cobranças e serviços extras a cada estadia.`,
    ctaStart: `Começar a configurar`,
    ctaPromotions: `Ver promoções globais`,
    perk1Title: `Zero comissões de OTA`,
    perk1Text: `Fique com 100% de cada reserva direta.`,
    perk2Title: `Pagamento e confirmação instantâneos`,
    perk2Text: `O hóspede paga e a reserva se confirma automaticamente.`,
    perk3Title: `Promoções e cobranças extras`,
    perk3Text: `Descontos de estadia, serviços e suas próprias cobranças.`,
    perk4Title: `Um link por propriedade`,
    perk4Text: `Cada anúncio com seu próprio motor e disponibilidade.`,
  },

  unitsList: {
    title: `Unidades disponíveis`,
    subtitle: `Ative as unidades que você quer exibir no seu motor de reservas.`,
    loading: `Carregando…`,
    sectionUnits: `Unidades`,
    colUnit: `Unidade`,
    colCap: `Cap.`,
    colActive: `Ativa`,
    noUnits: `Nenhuma unidade configurada.`,
    active: `Ativa`,
    inactive: `Inativa`,
    noticePrefix: `Ative as reservas diretas em`,
    noticeGlobalConfig: `Configurações globais`,
    noticeSuffix: `para gerenciar as unidades.`,
    sectionLink: `Link individual do apartamento`,
    linkCardTitle: `Link filtrado para este apartamento`,
    linkCardDesc: `Abre o mesmo motor de reservas geral, mas mostrando este apartamento diretamente.`,
    viewAsVisitor: `Ver como visitante`,
    unitUpdated: `Unidade atualizada.`,
    updateError: `Não foi possível atualizar.`,
    noLinkCopy: `Nenhum link para copiar.`,
    linkCopied: `Link copiado.`,
    copyError: `Não foi possível copiar o link.`,
    noLinkOpen: `Nenhum link para abrir.`,
  },

  commonAreaImages: {
    intro: `Fotos gerais (entrada, piscina, recepção, jardim…) exibidas ao hóspede como capa quando ele abre o motor, junto com a galeria de cada unidade.`,
    imagesCount: `{count} imagem | {count} imagens`,
    reorderHint: `Arraste para reordenar · a principal é a capa`,
    reordering: `Reordenando…`,
    dragTitle: `Arrastar`,
    coverBadge: `Capa`,
    empty: `Você ainda não adicionou fotos das áreas comuns. Envie-as acima para criar a capa do anúncio.`,
    loadError: `Não foi possível carregar as fotos das áreas comuns.`,
    uploadSuccess: `Fotos enviadas com sucesso.`,
    uploadError: `Não foi possível enviar as imagens.`,
    orderUpdated: `Ordem atualizada.`,
    orderError: `Não foi possível atualizar a ordem.`,
    deleteConfirmMsg: `Excluir esta foto de área comum?`,
    deleteConfirmHeader: `Excluir imagem`,
    deleteAccept: `Excluir`,
    deleteReject: `Cancelar`,
    imageDeleted: `Imagem excluída.`,
    deleteError: `Não foi possível excluir a imagem.`,
    coverUpdated: `Capa atualizada.`,
    coverError: `Não foi possível definir a capa.`,
    invalidFiles: `Arquivos inválidos: {message}\n{details}`,
  },
};
